<div class="col-12 p-0">
    <div class="row align-items-center">
        <img src="./assets/icons/arrow.svg" />
        <span class="section-title ml-2 mr-1">Programa de pontos</span>
    </div>

    <div class="row main-block">
        <div class="data">
            <span class="field-label">Quantidade de pontos ganhos até o momento: <span class="field-value">{{donations}}</span></span>
        </div>
        <div class="line mt-2 mb-2"></div>
        <div class="col-12 mt-2">
            <div class="row clickable justify-content-between">
                <a href="https://site.bankei.com/" target="_blank" class="status-label">Clique aqui e saiba como funciona</a>
            </div>
        </div>
    </div>
</div>
